import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setUsers = users => {
	return {
		type: ActionTypes.LOAD_USERS,
		users: users.data
	};
};

export const loadUsers = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
			.get(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users/",
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				if (response != undefined) dispatch(setUsers(response.data));
			})
			.catch(error => {});
	};
};

export const loadUsersMonth = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
			.get(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users/month",
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				if (response != undefined) dispatch(setUsers(response.data));
			})
			.catch(error => {});
	};
};

export const loadUsersWeek = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
			.get(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users/week",
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				if (response != undefined) dispatch(setUsers(response.data));
			})
			.catch(error => {});
	};
};
